import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import TicketDashboard from './pages/TicketDashboard';
import Profile from './pages/Profile';
import AdminUsers from './pages/AdminUsers';
import RolePermissions from './pages/RolePermissions';
import MenuConfig from './pages/MenuConfig';
import CompanyManagement from './pages/CompanyManagement';
import CompanyUsers from './pages/CompanyUsers';
import ClaudeConnector from './pages/ClaudeConnector';
import CannedResponses from './pages/CannedResponses';
import Rules from './pages/Rules';
import SlaSettings from './pages/SlaSettings';
import Knowledge from './pages/Knowledge';
import Reports from './pages/Reports';
import AuditLog from './pages/AuditLog';
import Tickets from './pages/Tickets';
import TicketDetail from './pages/TicketDetail';
import TicketProjectFields from './pages/TicketProjectFields';
import TicketProjectNotifications from './pages/TicketProjectNotifications';
import TicketProjectMailbox from './pages/TicketProjectMailbox';
import TicketProjects from './pages/TicketProjects';
import Automations from './pages/Automations';
import ProjectTemplates from './pages/ProjectTemplates';
import Customers from './pages/Customers';
import Meetings from './pages/Meetings';
import MeetingNew from './pages/MeetingNew';
import MeetingDetail from './pages/MeetingDetail';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import PortalApp from './pages/portal/PortalApp';
import { createApp } from './kernelApp';
import { canAccessPage, getDefaultPath } from './menu';

const App = createApp({
  Login,
  canAccessPage,
  getDefaultPath,
  routes: ({ user, isAuthenticated, Guarded, handleLogout, handleUserUpdate }) => (
    <>
      <Route
        path="/dashboard"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="dashboard">
              <TicketDashboard user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/tickets"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="tickets">
              <Tickets user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/tickets/:id"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="tickets">
              <TicketDetail user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/ticket-projects"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="ticket-projects">
              <TicketProjects user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/ticket-projects/:id/fields"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="ticket-projects">
              <TicketProjectFields user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/ticket-projects/:id/notifications"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="ticket-projects">
              <TicketProjectNotifications user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/ticket-projects/:id/mailbox"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="ticket-projects">
              <TicketProjectMailbox user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/customers"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="customers">
              <Customers user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/projects"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="projects">
              <Projects user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/projects/:id"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="projects">
              <ProjectDetail user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/project-templates"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="projects">
              <ProjectTemplates user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/reports"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="reports">
              <Reports user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/rules"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="rules">
              <Rules user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/sla"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="sla">
              <SlaSettings user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/knowledge"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="knowledge">
              <Knowledge user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/canned-responses"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="canned">
              <CannedResponses user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/claude"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="claude">
              <ClaudeConnector user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/automations"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="automations">
              <Automations user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/meetings"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="meetings">
              <Meetings user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/meetings/new"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="meetings">
              <MeetingNew user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/meetings/:id"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="meetings">
              <MeetingDetail user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/profile"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="profile">
              <Profile user={user} onLogout={handleLogout} onUserUpdate={handleUserUpdate} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/admin"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="admin">
              <AdminUsers user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/permissions"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="permissions">
              <RolePermissions user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/menu-config"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="menu-config">
              <MenuConfig user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/companies"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="companies">
              <CompanyManagement user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/companies/:id/users"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="companies">
              <CompanyUsers user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/audit"
        element={
          isAuthenticated ? (
            <Guarded user={user} page="audit">
              <AuditLog user={user} onLogout={handleLogout} />
            </Guarded>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Portale clienti: albero di route indipendente, con un proprio stato di
          autenticazione (CustomerAuthMiddleware, non AuthMiddleware) — non passa
          da Guarded/canAccessPage, che sono legati a ruolo/menu dello staff. */}
      <Route path="/portal/*" element={<PortalApp />} />

      <Route path="/" element={<Navigate to={isAuthenticated ? getDefaultPath(user) : '/login'} replace />} />
      <Route path="*" element={<Navigate to={isAuthenticated ? getDefaultPath(user) : '/login'} replace />} />

    </>
  ),
});

export default App;
